import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './attachmentSelector.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import TabContainer from '../../../moreCore/UI/Tabbing/TabContainer';
import "WidgetCollection/EMail/attachments/uploadedFilesDisplay"
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import email_FileUploader from './FileUploader';
import RequestManager from 'more/RequestManager';
import { EmailEditorTypes } from "../emailTypes";

class email_AttachmentSelector extends compose(_GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    myDlg:MdsLax<InstanceType<typeof GenericDialog>>;

    tabbedContainerDiv:HTMLDivElement;
    tabbedContainer:MdsLax<InstanceType<typeof TabContainer>>;

    mailFormContext: EmailEditorTypes.mailFormContext;

    tabContent: Object = {};

    mainContainer:HTMLDivElement;

    reqMgr:RequestManager;

    emailFileUploaderNewFile: MdsLax<InstanceType<typeof email_FileUploader>>;
    uploadNewFileDlg:MdsLax<InstanceType<typeof GenericDialog>>;
    private flagNewFileDlgWasShow = false;

    postCreate() {
        this.SEDconfigCallfunction = "Webtool_API_EmailTransmission_FileSuggestion___GetSEDconfig";

        //dadurch da das upFilesMenuWidget bereits emitet, reichen wir die file data vom uploader nur durch
        this.emailFileUploaderNewFile.on("newFile", lang.hitch((newFile: EmailEditorTypes.MailDataFile) => {
            this.emit("newFile", newFile);
        }));
        this.emailFileUploaderNewFile.on("removedFile", lang.hitch((fileID: string) => {
            this.emit("removedFile", fileID);
        }));

        this.emailFileUploaderNewFile.on("displayPopupMsg", lang.hitch(this, this.displayPopupMsg));
    }

    public openDlg(ev: MouseEvent) {
        this.loadSelectEntityDialog(
            ev,
            JSON.stringify(this.mailFormContext),
            lang.hitch(this, this._dlgCallback),
            lang.hitch(this, this._onClick_UploadFile)
        );
    }

    private _onClick_UploadFile(ev:any){
        if (this.flagNewFileDlgWasShow == false) {

            this.uploadNewFileDlg = new GenericDialog();
            this.uploadNewFileDlg.closeOnEnter = false;
            this.uploadNewFileDlg.closeOnEscape = false;
            this.uploadNewFileDlg.destroyOnClose = false;
            this.uploadNewFileDlg.setSize('smaller');

            this.uploadNewFileDlg.show(
                this.emailFileUploaderNewFile,
                this.translations["email_mailForm_label_FileUpload"],
                null,
                null,
                'ok',
                lang.hitch(this, this._onClose_NewFileUpload)
            );
        }else{
            this.uploadNewFileDlg.show();
        }
    }

    private _onClose_NewFileUpload(ev:any){
        //this.openDlg(ev);
    }

    async _dlgCallback(mode: Array<object>, data: Array<object>, items: Array<{ node: HTMLElement, entry: {data:Object, label:string, secondaryLabel:string, value:string}}>) {
        if (typeof items != 'undefined'){
            if (items != null){
                for (let it of items){
                    let targetID = it.entry.value;
                    let res:any = {};
                    try{
                        res = await this.APIconvertGeneralFile(targetID);
                        if (typeof res == 'boolean'){
                            throw "unable to convert file";
                        }
                    }catch{
                        this.displayPopupMsg({ msg: this.translations["email_fileUpload_onError_convertingGeneralFile"], isError:true, isWarning:false});
                        console.error("unable to convert vt_files to mail attachment ID=" + targetID);
                        return;
                    }
                    this.emailFileUploaderNewFile.addFile(res["filename"], res["htFileID"]); //newFile wird durch child widget nach oben emited
                }
            }
        }
    }

    public async APIconvertGeneralFile(fileID:string) {
        let dat = {fileID:fileID};
        let postData = JSON.stringify(dat);
        let apiURL = window.appRoot + "EMail/ConvertGeneralFile";
        return new Promise((resolve, reject) => {
            this.reqMgr.post(apiURL, { mailDataJson: postData },
                (response) => {
                    if (response.hasOwnProperty("filename") && (!response.hasOwnProperty("fileName"))) {
                        response["fileName"] = response["filename"];
                    }
                    if ((!response.hasOwnProperty("filename")) && (response.hasOwnProperty("fileName"))) {
                        response["filename"] = response["fileName"];
                    }
                    resolve(response);
                },
                (error) => {
                    reject(false);
                }
            ),
                null
        });
    }

    public async APIconvertUploadedFile(uploadData: EmailEditorTypes.mailFileUploadToConvert){
        return await this.emailFileUploaderNewFile.APIconvertUploadedFile(uploadData);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public getFileUploadRecord(){
        return this.emailFileUploaderNewFile.getRecordState();
    }

    public setFileUploadRecord(rec:any){
        this.emailFileUploaderNewFile.setRecordState(rec);
    }

    public setMailFormContext(mailFormContext: EmailEditorTypes.mailFormContext) {
        this.mailFormContext = mailFormContext;
    }

    private displayPopupMsg(ev: { msg: string, isError: boolean, isWarning: boolean }){
        this.emit("displayPopupMsg", ev);
    }

}

mdsLazyProto(email_AttachmentSelector.prototype, {
  reqMgr: () => (new RequestManager()),
  emailFileUploaderNewFile: () => (new email_FileUploader()),
});
export default mdsWidget(email_AttachmentSelector);
